(() => {
  const selectors = '[data-nevash-offer-popup]';

  function storageAvailable(type) {
    try {
      const storage = window[type];
      storage.setItem('__nevash_test__', '1');
      storage.removeItem('__nevash_test__');
      return storage;
    } catch (_) {
      return null;
    }
  }

  function initPopup(popup) {
    if (popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';

    const enabled = popup.dataset.enabled === 'true';
    const designMode = popup.dataset.designMode === 'true';
    if (!enabled && !designMode) return;

    const dialog = popup.querySelector('[role="dialog"]');
    const closeButtons = popup.querySelectorAll('[data-offer-close]');
    const copyButton = popup.querySelector('[data-offer-code]');
    const frequency = popup.dataset.frequency || 'days';
    const campaign = popup.dataset.campaign || 'default';
    const key = `nevash-offer-${campaign}`;
    const localStore = storageAvailable('localStorage');
    const sessionStore = storageAvailable('sessionStorage');
    let previousFocus = null;

    const shouldOpen = () => {
      if (designMode) return true;
      if (frequency === 'always') return true;
      if (frequency === 'session') return sessionStore?.getItem(key) !== 'seen';
      const lastSeen = Number(localStore?.getItem(key) || 0);
      const days = Number(popup.dataset.days || 7);
      return !lastSeen || Date.now() - lastSeen >= days * 86400000;
    };

    const markSeen = () => {
      if (designMode) return;
      if (frequency === 'session') sessionStore?.setItem(key, 'seen');
      if (frequency === 'days') localStore?.setItem(key, String(Date.now()));
    };

    const open = () => {
      if (!popup.hidden && popup.classList.contains('is-open')) return;
      previousFocus = document.activeElement;
      popup.hidden = false;
      requestAnimationFrame(() => {
        popup.classList.add('is-open');
        document.body.classList.add('nevash-popup-open');
        dialog?.focus();
      });
      markSeen();
    };

    const close = () => {
      popup.classList.remove('is-open');
      document.body.classList.remove('nevash-popup-open');
      window.setTimeout(() => { popup.hidden = true; }, 260);
      previousFocus?.focus?.();
    };

    closeButtons.forEach((button) => button.addEventListener('click', close));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) close();
      if (event.key !== 'Tab' || !popup.classList.contains('is-open')) return;
      const focusable = [...popup.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    copyButton?.addEventListener('click', async () => {
      const code = copyButton.dataset.offerCode;
      try {
        await navigator.clipboard.writeText(code);
      } catch (_) {
        const input = document.createElement('textarea');
        input.value = code;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }
      const label = copyButton.querySelector('[data-offer-copy-label]');
      if (label) {
        label.textContent = 'Copied';
        window.setTimeout(() => { label.textContent = 'Copy'; }, 1800);
      }
    });

    if (shouldOpen()) window.setTimeout(open, designMode ? 100 : Number(popup.dataset.delay || 0));
    popup.addEventListener('shopify:block:select', open);
    popup.addEventListener('shopify:section:select', open);
  }

  const initAll = (root = document) => root.querySelectorAll(selectors).forEach(initPopup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
